import AnimationFactory from "../../../../../shared/lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../shared/lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import AbstractCommand from "../../../../../shared/src/ranj/app/core/AbstractCommand";
import NavigateEvent from "../../../../../shared/src/ranj/app/navigation/NavigateEvent";
import SkinKeys from "../../../../../shared/src/ranj/app/ui/SkinKeys";
import GameModel from "../model/GameModel";
import NGTVariableManager from "../ngt/base/NGTVariableManager";

export default class TransitionToDialogCommand extends AbstractCommand {

    /**
     * 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {NGTVariableManager} variableManager 
     * @param {GameModel} gameModel 
     */
    constructor(dispatcher, scenarioPlayer) {
        super(dispatcher);

        this.execute = function({ params }) {
            const { dialogIndex, content } = params;
            const dialogID = `dialog${dialogIndex}`;//CONVENTION, NB: dialogIndex starts at 1
            this.gotoScreen(
                SkinKeys.TRANSITION_SCREEN,
                {
                    dialogID: dialogID, onClose: () => {
                        //completion of SetVariable content will trigger next dialog in story:
                        scenarioPlayer.contentCompleted(content);
                    }
                }
            );
        }
    }
}
